var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coins",
    d: "M13.75,0C10.245,0,7.5,1.647,7.5,3.75V5.906a10.68,10.68,0,0,0-1.25-.073C2.745,5.833,0,7.481,0,9.583V16.25C0,18.353,2.745,20,6.25,20c2.839,0,5.18-1.081,5.967-2.609a10.661,10.661,0,0,0,1.533.109c3.5,0,6.25-1.648,6.25-3.75v-10C20,1.647,17.255,0,13.75,0Zm4.583,10.417c0,.983-1.96,2.083-4.583,2.083a9.029,9.029,0,0,1-1.25-.086V10.761a10.83,10.83,0,0,0,1.25.073,8.621,8.621,0,0,0,4.583-1.176ZM1.667,12.157A8.621,8.621,0,0,0,6.25,13.333a8.621,8.621,0,0,0,4.583-1.176v.759C10.833,13.9,8.873,15,6.25,15s-4.583-1.1-4.583-2.083ZM18.333,7.083c0,.983-1.96,2.083-4.583,2.083a9.034,9.034,0,0,1-1.305-.093,3.3,3.3,0,0,0-1.422-1.936A10.01,10.01,0,0,0,13.75,7.5a8.621,8.621,0,0,0,4.583-1.176ZM13.75,1.667c2.623,0,4.583,1.1,4.583,2.083s-1.96,2.083-4.583,2.083S9.167,4.733,9.167,3.75,11.127,1.667,13.75,1.667ZM6.25,7.5c2.623,0,4.583,1.1,4.583,2.083s-1.96,2.083-4.583,2.083-4.583-1.1-4.583-2.083S3.627,7.5,6.25,7.5Zm0,10.833c-2.623,0-4.583-1.1-4.583-2.083v-.759A8.621,8.621,0,0,0,6.25,16.667a8.621,8.621,0,0,0,4.583-1.176v.759C10.833,17.233,8.873,18.333,6.25,18.333Zm7.5-2.5a9.029,9.029,0,0,1-1.25-.086V14.094a10.831,10.831,0,0,0,1.25.072,8.621,8.621,0,0,0,4.583-1.176v.759C18.333,14.733,16.373,15.833,13.75,15.833Z",
    fill: "#072430",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.630f3a2e5ffeb68885ff983106087c72.svg";
export { ForwardRef as ReactComponent };